/**
 * Pages outside the application that it points people to.
 */

/** « Staffing, prise en main » : how to use the staffing in Claude (plugin `equancy-staffing`). */
export const CLAUDE_GUIDE_URL = 'https://claude.ai/artifact/3inyfD2XYA9yzkzFmTwCwh?sk=TGFJGbUqOvAsECUdbbGA3g';
